module.exports = __webpack_public_path__ + "static/lhc-71090bdfd3bc8acd4a498aa11a211e16.jpg";